module.exports = __webpack_public_path__ + "static/media/car.47cc7606.jpg";